enum EStorage {
    MULTI_SHOPPING_CART_UUID = 'multiShoppingCartUuid',
    TOKEN = 'token',
    TOKEN_EXPIRES_IN = 'tokenExpiresIn',
    TIME_TO_CLOSE_MODAL = 'timeToCloseModal',
    DEVELOP_CONFIG = 'developConfig',
    BASKET_LINK = 'basketLink',
    MARKET_SEGMENT = 'marketSegment',
    IS_CLEAR_BASKET_SESSION = 'isClearBasketSession',
    PAYMENT_STARTED = 'paymentStarted',
    FUT_USER_VERIFICATION = 'FutUserVerification',
    PAGE_RELOAD = 'page_reload',
    PAGEVIEW_ID = 'pageview_id',
    SESSION_ID = 'session_id',
    PRODUCTS_AXIS_POSITION = 'products_axis_position',
    POS_FAILED_RESERVATION_ID = 'pos_failed_reservation_id',
    CONSENTS_STORE = 'consents_store',
    IS_4_STEP_A_DOCUMENTS = 'is_4_step_a_documents',
}

export default EStorage
